import { Component, OnInit, Input, ViewChild, ElementRef } from '@angular/core';
import { NgbModal, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { SupplierOrderLineModel } from './../models/supplier-order-line.model';
import { SupplierOrderPalletModel } from './../models/supplier-order-pallet.model';
import { SupplierOrderService } from './../services/supplier-order.service';
import { LocalDataSource, ViewCell } from 'ng2-smart-table';
import { Ng2SmartTableComponent } from 'ng2-smart-table/ng2-smart-table.component';
import { UiSettings, ZHelpers } from './../../common';
import { PalletQtyRenderComponent } from './pallet-qty-render.component';


@Component({
    selector: 'ngbd-modal-content',
    templateUrl: './order-details-view.template.html',
    styleUrls: ['./order-details-view.style.scss'],
})
export class OrderDetailsViewComponent implements OnInit {
    @Input() orderLine: SupplierOrderLineModel;
    @ViewChild('smt') table: Ng2SmartTableComponent;
    pallets: SupplierOrderPalletModel[] = null;
    selectedPallets: SupplierOrderPalletModel[] = null;
    qtyState: string;
    printSize: string = '2';
    generationStatus: string;
    tableSource = new LocalDataSource();
    public tableSettings = {
        ...UiSettings.defaultSmartTableSettings,
        selectMode: 'multi',
        actions: false,
        columns: {
            id: { title: 'Pallet no', valuePrepareFunction: ZHelpers.OrderPallets.foramtPalletId },
            qty: {
                title: 'Amount', type: 'custom', renderComponent: PalletQtyRenderComponent,
            },
            printQty: {
                type: 'html',
                title: 'Printed', valuePrepareFunction: (cell, row) => {
                    if (cell > 0) {
                        return `<span title="x${cell}">Yes</span>`;
                    }
                    return 'No';
                }
            },
        },
    }

    constructor(public activeModal: NgbActiveModal, protected supplierOrderService: SupplierOrderService) {
    }

    ngOnInit(): void {
        this.loadData();
    }

    onGeneratePalletsClick() {
        this.supplierOrderService.generatePallets(
            this.orderLine.orderNo, this.orderLine.ifsId,
            this.orderLine.qty, this.orderLine.stdQty)
            .subscribe(data => this.loadData());
    }

    onAddNewPalletClick() {
        this.supplierOrderService.addPallet(this.orderLine.ifsId, 1)
            .subscribe(newId => {
                const model = new SupplierOrderPalletModel();
                model.id = newId;
                model.lineIfsId = this.orderLine.ifsId;
                model.printQty = '0';
                model.qty = '1';
                this.tableSource.append(model);
            })
    }

    onSelectNotPrintedClick() {
        const notPrinted = this.table.grid.dataSet.getRows()
            .forEach(row => row.isSelected = (row.getData().printQty === 0));
        this.table['emitUserSelectRow'](null);
        this.table['emitSelectRow'](null);
    }

    onPrintSelected() {
        let pairs = '';
        this.selectedPallets.map(pallet => {
            //hacking time..
            pallet.qty = (<any>window.document.getElementById('pallet_' + pallet.id + '_qty')).value;
            pairs += '&i=' + pallet.id + ',' + pallet.qty;
        });

        if (pairs === '') {
            return;
        }
        const sURL = UiSettings.environment.apiUrl
            + '/suppliers/pallets/barcodes?lineIfsId='
            + this.orderLine.ifsId + pairs
            + '&size=' + this.printSize;

        ZHelpers.Common.printPage(sURL);
        this.activeModal.close();
    }

    onRowSelected(e) {
        if (e.selected && e.selected.length > 0) {
            this.selectedPallets = e.selected;
        } else {
            this.selectedPallets = null;
        }
    }

    handleQtyChange(newQtyPerPallet) {
        this.orderLine.stdQty = newQtyPerPallet;
        this.generateStatus();
    }

    generateStatus() {
        if (this.isGenerated()) {
            this.generationStatus = '';
            return;
        }
        const fullPallets = Math.floor(this.orderLine.qty / this.orderLine.stdQty);
        const reminder = this.orderLine.qty % this.orderLine.stdQty;
        let state = `${fullPallets} full pallet` + (fullPallets > 1 ? 's' : '');
        if (reminder > 0) {
            state += ` / 1 partial pallet with ${reminder} items`;
        }
        this.generationStatus = state;
    }

    loadData() {
        this.tableSource.load([]);
        this.supplierOrderService.getPallets(this.orderLine.ifsId)
            .subscribe(data => {
                this.pallets = data;
                ZHelpers.SmartTable.setData(this.tableSource, data);
                this.generateStatus();
            });
    }

    isGenerated() {
        return this.pallets && this.pallets.length > 0;
    }
}




// WEBPACK FOOTER //
// ./src/app/suppliers-barcodes/details-view/order-details-view.component.ts